export interface TripPlannerHubQueryInput {
    lat1: number;
    lon1: number;
    lat2: number;
    lon2: number;
    startTime: string;
    agencyId?: string;
    fromHubId?: string | null;
    toHubId?: string | null;
    includeShape?: boolean;
    useTrains?: boolean;
    useBuses?: boolean;
    useBicycles?: boolean;
}

export function buildTripPlannerQueryParams(input: TripPlannerHubQueryInput): Record<string, string> {
    let time = new Date(new Date().toLocaleDateString('en-us') + ' ' + input.startTime).toISOString();
    time = time.substr(0, time.length - 5);

    const queryParams: Record<string, string> = {
        lat1: input.lat1.toString(),
        lon1: input.lon1.toString(),
        lat2: input.lat2.toString(),
        lon2: input.lon2.toString(),
        startTime: time,
        useTrains: (input.useTrains ?? true).toString(),
        useBuses: (input.useBuses ?? true).toString(),
        useBicycles: (input.useBicycles ?? false).toString(),
        includeShape: (input.includeShape ?? true).toString(),
    };

    if (input.agencyId) {
        queryParams.agencyId = input.agencyId;
    }

    if (input.fromHubId) {
        queryParams.fromHubId = input.fromHubId;
    }

    if (input.toHubId) {
        queryParams.toHubId = input.toHubId;
    }

    return queryParams;
}
